module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_1024.7edb66f6.webp";